<p>
    wow, what a con it's been! Wouldn't it be great to have a smaller, relaxed cruise with friends, chill music and drinks around different parts of Hamburg?
    The numbers don't lie, furries love boating, which is why we've come up with an additional opportunity to get on the water. On Sunday September 7th, 2025 at 14:30,
    we'll be boarding a Barkasse at Überseebrücke for a nice 3 hour trip to other parts of Hamburg.
</p>
<div class="pricing">
    <div class="pricing-unit">
        <h3>Standard Ticket &mdash; 30&euro;</h3>
        <ul>
            <li>Access to cabin and amenities</li>
        </ul>
    </div>
</div>
<p>
    This <strong>smaller boat</strong> offers half the capacity of our party boat and will primarily happen seated,
    it's equiped with a <strong>bar for drinks and snacks</strong>, plenty of cider and chill music.
    However, due to the size and type of the event, we <strong>won't be able to provide a fursuit lounge</strong>. Take a partial or stay suited during the entire cruise (emergency unsuiting possible in restrooms).
</p>
